<template>
  <div :class="classes">
    <!-- 左侧区域插槽 -->
    <slot name="lt" />
    <div class="wt-row__content">
      <!-- 中间区域插槽 -->
      <slot />
    </div>
    <!-- 右侧区域插槽 -->
    <slot name="rt" />
    <wt-box class="wt-row__arrow" v-if="arrow">
        <slot name="arrow">
            <img class="wt-icon--fit" src="../../../assets/svg/arrow-right.svg">
        </slot>
    </wt-box>
  </div>
</template>

<script>
import wtBox from '../box'
// 组件class前缀
const prefixCls = 'wt-row'

export default {
  name: 'wt-row',
  props: {
    // 是否在右侧显示向右的箭头
    arrow: {
      type: Boolean,
      default: false
    }
  },
  components: {
    wtBox
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  }
}
</script>

<style lang="less">
.wt-row {
  display: flex;
  flex-direction: row;
  position: relative;
  &__content {
    flex: 1;
    display: flex;
    padding: 0 0.06rem;
  }
}
</style>
